<mat-card class="cardWithShadow w-50">
    <mat-card-content>
  
      <div class="table-responsive m-t-30">
      </div>
      
    </mat-card-content>
</mat-card>